import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

import ProductCardComponent from '@prisjakt/ui-product-card';
import ProductImageComponent from '@prisjakt/ui-product-image';

type CardProps = {
  columns: number;
};

export const ProductCard = styled(ProductCardComponent)<CardProps>(
  props => css`
    && {
      min-width: 148px;

      flex: 1 0 ${100 / props.columns}%;

      ${media.mediumOnly`
      flex: 1 0 33%;
    `};

      ${media.smallOnly`
      flex: 1 0 50%;
    `}
    }
  `
);

export const ProductImage = styled(ProductImageComponent)`
  max-width: 100%;
`;
